var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"checkout-container"},[_c('FormTitle',{staticClass:"checkout-container__title",attrs:{"title":_vm.$t('checkout.shippingMethod')}}),_c('div',{staticClass:"customer-details"},[_c('div',[_vm._v(" "+_vm._s(_vm.shipping.method)+" - $"+_vm._s(_vm.formatNumber(_vm.shipping.cost))+" ")])])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }